import * as r from 'ramda';
import { createSelector } from 'reselect';

const getApp = r.prop('app');

export const getOnboardingSteps = r.pipe(getApp, r.prop('onboardingSteps'));

export const getIsOnboardingCompleted = createSelector(getOnboardingSteps, (onboardingSteps) =>
  onboardingSteps.every((step) => step.status === 'completed')
);
